import type {
  Client,
  DirectoryParticipant,
  DirectoryUser,
  DocumentTemplate,
  IssuingEntity,
  NumberingScheme,
  TransportRef,
} from '@/types/domain'

export const MOCK_CLIENTS: Client[] = [
  {
    id: 'cl1',
    name: 'Beg Logistics',
    code: 'BEG',
    taxId: '1024578841',
    country: 'Turkmenistan',
    address: 'Ashgabat, Turkmenbashi ave. 54',
    ownerId: 'u-2',
    isActive: true,
    contacts: [
      {
        id: 'ct1',
        label: 'Dispatch',
        email: 'ops@beglogistics.tm',
        phone: '+993 12 45 88 21',
        wechat: '',
        telegram: 'beg_ops',
        whatsapp: '',
        isPrimary: true,
      },
    ],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'cl2',
    name: 'Türkmen Gurluşyk',
    taxId: '1024411907',
    country: 'Turkmenistan',
    address: 'Ashgabat, Bitarap Turkmenistan 12',
    ownerId: 'u-5',
    isActive: true,
    contacts: [],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'cl3',
    name: 'Yiwu Trading House',
    code: 'YTH',
    country: 'China',
    address: 'Yiwu, Zhejiang',
    ownerId: 'u-4',
    isActive: false,
    contacts: [],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
]

/* The seven types, distinct (FR-40). Agent-typed rows are absent from a Sales
 * user's real API response rather than redacted — these fixtures are the
 * founder's view, which is why agents appear here at all. */
export const MOCK_PARTICIPANTS: DirectoryParticipant[] = [
  {
    id: 'dp1',
    name: 'Hebei Cross Border Ltd',
    type: 'agent',
    country: 'China',
    ownerId: 'u-4',
    isActive: true,
    contacts: [
      {
        id: 'ct2',
        label: 'Sun Di',
        email: 'sun.di@hbcross.cn',
        phone: '+86 311 8842 1120',
        wechat: 'hbcross_ops',
        telegram: '',
        whatsapp: '',
        isPrimary: true,
      },
    ],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'dp2',
    name: 'KTZ Express',
    type: 'counter-agent',
    country: 'Kazakhstan',
    ownerId: 'u-4',
    isActive: true,
    contacts: [],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'dp3',
    name: 'Ovezov Transport',
    type: 'vehicle-owner',
    country: 'Turkmenistan',
    ownerId: 'u-3',
    isActive: true,
    contacts: [
      {
        id: 'ct3',
        label: 'Dispatch',
        email: '',
        phone: '+993 65 22 14 09',
        wechat: '',
        telegram: '',
        whatsapp: '99365221409',
        isPrimary: true,
      },
    ],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'dp4',
    name: 'Yiwu Textiles Co',
    type: 'shipper',
    country: 'China',
    ownerId: 'u-4',
    isActive: true,
    contacts: [],
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
]

export const MOCK_USERS: DirectoryUser[] = [
  {
    id: 'u-1',
    name: 'Arslan Kerimov',
    email: 'arslan@asagateway.com',
    role: 'super-admin',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: true,
      manageParticipants: true,
      manageTransport: true,
    },
    capabilities: ['directory.client.manage', 'directory.participant.manage', 'directory.transport.manage'],
    userCapabilities: ['directory.client.manage', 'directory.participant.manage', 'directory.transport.manage'],
    isActive: true,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'u-2',
    name: 'Merjen Atayeva',
    email: 'merjen@asagateway.com',
    role: 'sales',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: true,
      manageParticipants: false,
      manageTransport: false,
    },
    capabilities: ['directory.client.manage'],
    userCapabilities: ['directory.client.manage'],
    isActive: true,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:01:00Z',
    updatedAt: '2026-07-31T09:01:00Z',
  },
  {
    id: 'u-3',
    name: 'Aygul Nazarova',
    email: 'aygul@asagateway.com',
    role: 'operations',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: false,
      manageParticipants: false,
      manageTransport: false,
    },
    capabilities: [],
    userCapabilities: [],
    isActive: true,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:02:00Z',
    updatedAt: '2026-07-31T09:02:00Z',
  },
  {
    id: 'u-4',
    name: 'Sun Di',
    email: 'sundi@asalogistics.cn',
    role: 'pricing',
    office: 'Yiwu',
    language: 'en',
    grants: {
      manageClients: false,
      manageParticipants: true,
      manageTransport: false,
    },
    capabilities: ['directory.participant.manage'],
    userCapabilities: ['directory.participant.manage'],
    isActive: true,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:03:00Z',
    updatedAt: '2026-07-31T09:03:00Z',
  },
  {
    id: 'u-5',
    name: 'Merdan Ovezov',
    email: 'merdan@asagateway.com',
    role: 'sales',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: false,
      manageParticipants: false,
      manageTransport: false,
    },
    capabilities: [],
    userCapabilities: [],
    isActive: true,
    mustChangePassword: true,
    createdAt: '2026-07-31T09:04:00Z',
    updatedAt: '2026-07-31T09:04:00Z',
  },
  {
    id: 'u-6',
    name: 'Gulnar Rejepova',
    email: 'gulnar@asagateway.com',
    role: 'finance',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: false,
      manageParticipants: false,
      manageTransport: false,
    },
    capabilities: [],
    userCapabilities: [],
    isActive: true,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:05:00Z',
    updatedAt: '2026-07-31T09:05:00Z',
  },
  {
    id: 'u-7',
    name: 'Kerim Saparov',
    email: 'kerim@asagateway.com',
    role: 'operations',
    office: 'Ashgabat',
    language: 'ru',
    grants: {
      manageClients: false,
      manageParticipants: false,
      manageTransport: false,
    },
    capabilities: [],
    userCapabilities: [],
    isActive: false,
    mustChangePassword: false,
    createdAt: '2026-07-31T09:06:00Z',
    updatedAt: '2026-07-31T09:06:00Z',
  },
]

export const MOCK_TRANSPORT: TransportRef[] = [
  { id: 'tr1', kind: 'mode', label: 'Rail', code: 'RAIL', isActive: true, sortOrder: 10 },
  { id: 'tr2', kind: 'mode', label: 'Sea', code: 'SEA', isActive: true, sortOrder: 20 },
  { id: 'tr3', kind: 'mode', label: 'Road', code: 'ROAD', isActive: true, sortOrder: 30 },
  { id: 'tr4', kind: 'mode', label: 'Air', code: 'AIR', isActive: true, sortOrder: 40 },
  { id: 'tr5', kind: 'mode', label: 'Multimodal', code: 'MULTI', isActive: true, sortOrder: 50 },
  { id: 'tr6', kind: 'equipment', label: "40' High Cube", code: '40HC', isActive: true, sortOrder: 60 },
  { id: 'tr7', kind: 'equipment', label: "40' Standard", code: '40DC', isActive: true, sortOrder: 70 },
  { id: 'tr8', kind: 'equipment', label: "20' Standard", code: '20DC', isActive: true, sortOrder: 80 },
  { id: 'tr9', kind: 'equipment', label: 'Tilt trailer', code: 'TILT', isActive: true, sortOrder: 90 },
  { id: 'tr10', kind: 'equipment', label: 'Reefer 40′', code: '40RF', isActive: false, sortOrder: 100 },
]

export const MOCK_ENTITIES: IssuingEntity[] = [
  {
    id: 'ie1',
    name: 'ASA Gateway Ashgabat',
    initials: 'AB',
    officeCode: 'AB',
    defaultOffice: 'Ashgabat',
    legalFooter: 'ASA Gateway Company Limited · Ashgabat, Turkmenistan · Reg. 8841203',
    bankDetails: 'Türkmenbaşy Bank · USD acc. 2331 0044 8812 · SWIFT TVBTTM2X',
    emailSignature: 'ASA Gateway · Ashgabat office',
    logoVariant: 'lockup-horizontal-blue',
    logo: { has: false },
    isActive: true,
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
  {
    id: 'ie2',
    name: 'ASA Logistics Yiwu',
    initials: 'ASA',
    officeCode: 'YW',
    defaultOffice: 'Yiwu',
    legalFooter: 'ASA Logistics (Yiwu) Co. Ltd · Zhejiang, China · Reg. 91330782',
    bankDetails: 'Bank of China Yiwu · USD acc. 3771 8840 1102 · SWIFT BKCHCNBJ',
    emailSignature: 'ASA Logistics · Yiwu desk',
    logoVariant: 'lockup-horizontal-blue',
    logo: { has: false },
    isActive: true,
    createdAt: '2026-07-31T09:00:00Z',
    updatedAt: '2026-07-31T09:00:00Z',
  },
]

/* Two numbering styles coexisting is the point of FR-68: the Ashgabat AB-2
 * style and the Yiwu ASADN26070001 style resolve from the issuing entity rather
 * than being typed. Every (entity, kind) pair appears, configured or not. */
export const MOCK_NUMBERING: NumberingScheme[] = [
  { entityId: 'ie1', entityName: 'ASA Gateway Ashgabat', documentKind: 'quote', pattern: '{INITIALS}-Q-{seq}', configured: false, example: 'AB-Q-4', nextValue: 4 },
  { entityId: 'ie1', entityName: 'ASA Gateway Ashgabat', documentKind: 'case', pattern: '{INITIALS}-{seq}', configured: true, example: 'AB-28', nextValue: 28 },
  { entityId: 'ie1', entityName: 'ASA Gateway Ashgabat', documentKind: 'invoice', pattern: '{INITIALS}-{YYYY}-{seq:4}', configured: true, example: 'AB-2026-0185', nextValue: 185 },
  { entityId: 'ie1', entityName: 'ASA Gateway Ashgabat', documentKind: 'debit-note', pattern: '{INITIALS}-DN-{seq}', configured: false, example: 'AB-DN-1', nextValue: 1 },
  { entityId: 'ie2', entityName: 'ASA Logistics Yiwu', documentKind: 'quote', pattern: '{OFFICE}-Q-{seq}', configured: true, example: 'YW-Q-15', nextValue: 15 },
  { entityId: 'ie2', entityName: 'ASA Logistics Yiwu', documentKind: 'case', pattern: '{OFFICE}-{YY}/{seq}', configured: true, example: 'YW-26/59', nextValue: 59 },
  { entityId: 'ie2', entityName: 'ASA Logistics Yiwu', documentKind: 'invoice', pattern: '{INITIALS}-INV-{seq}', configured: false, example: 'ASA-INV-1', nextValue: 1 },
  { entityId: 'ie2', entityName: 'ASA Logistics Yiwu', documentKind: 'debit-note', pattern: 'ASADN{YY}{MM}{seq:4}', configured: true, example: 'ASADN26080002', nextValue: 2 },
]

export const MOCK_TEMPLATES: DocumentTemplate[] = [
  {
    id: 'tp1',
    kind: 'not-included',
    label: 'Standard exclusions — rail',
    body: 'Customs clearance at destination · Duties and taxes · Insurance · Storage beyond free time',
  },
  {
    id: 'tp2',
    kind: 'not-included',
    label: 'Standard exclusions — sea',
    body: 'Customs clearance · Duties and taxes · Insurance · Demurrage and detention · Port storage',
  },
  {
    id: 'tp3',
    kind: 'disclaimer',
    label: 'Validity and availability',
    body: 'Rates are valid until the date shown and are subject to space and equipment availability at the time of booking.',
  },
]
